import React, { useEffect, useRef, useState }from "react";
import { Modal, Input, Spin, notification } from "antd";
import _ from 'lodash';
import styled from "styled-components";
import { Icon } from 'dlweb-components';
import UserPicker from "../../UserPicker";

const NewGroupDialog = ({ open, onOk, onCancel, isCopy }) => {
  
  const inputRef = useRef(null);

  const [disabled, setDisabled] = useState(false);
  const [groupName, setGroupName] = useState('');

  useEffect(() => {
    setDisabled(true);
  }, [open])

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 100)
  }, [inputRef, open])

  const onDialogOk = () => {
    setDisabled(true)
    onOk(groupName);
  }

  const onChange = (e) => {
    e.target.value.length > 0 ? setDisabled(false) : setDisabled(true);
    setGroupName(e.target.value);
  }

  return (
    <Modal
      open={open}
      onOk={onDialogOk}
      onCancel={onCancel}
      width={400}
      destroyOnClose={true}
      maskClosable={false}
      getContainer="#container"
      okButtonProps={{disabled: disabled}}
      title={`${isCopy ? 'Copy' : 'New'} Group`}
    >
			<div>
        New Group Name
        <Input
          ref={inputRef}
          maxLength={50}
          onChange={onChange}
        />
			</div>
    </Modal>
  );
};

export default NewGroupDialog;
